module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.title + '-卡券领取记录',
      "name": "first"
    }
  }, [_c('receive', {
    attrs: {
      "get-status": _vm.receive
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": _vm.title + '-卡券使用记录',
      "name": "second"
    }
  }, [_c('used', {
    attrs: {
      "get-status": _vm.used
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dbe140bc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dbe140bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/cardticket/detail.vue
// module id = 2943
// module chunks = 0